
import React from "react";
import { useFormContext } from "react-hook-form";
import { isInvalidClass } from "../../config/helpers";

interface INameValue {
    name:string;
    value:string|number;
    defaultChecked:string|number;
}


interface IProps {
  label?: string;
  formName: string;
  ismandatory?: boolean;
  options:any;
  labelRight?: boolean; // Indique que le label est positionné à droite du checkbox
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxInput: React.FC<IProps> = ({
  formName,
  label = formName,
  ismandatory,
  options,
  labelRight,
  onChange,
}) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { register, getFieldState, formState: { errors } } = useFormContext();

  return (
    <div className="pae-form-section inline-inputs">
        {/* Affichage du label à gauche si labelRight est faux */}
          {!labelRight && (
            <>
              {label} {ismandatory && <em className="text-danger">*</em>}
            </>
          )}

      {options.map((option:INameValue, key:string) => (
        <div
          className="form-check-inline"
          key={key + "_" + formName}
        >
          <input
            className={`form-check-input ${isInvalidClass(getFieldState(formName).error)}`}
            id={key + "_" + option.name}
            {...register(formName)}
            type="checkbox"
            value={option.value}
            defaultChecked={option.defaultChecked === option.value}
            onChange={onChange}
            style={{ border: "1px solid"}}
            disabled={option.value === "disabled"}
          />
          <label
            className="form-check-label"
            htmlFor={key + "_" + option.name}
          >
            &nbsp;{option.name}
          </label>
        </div>
      ))}
      {/* {errors[formName] && <p className="text-danger">{errors[formName]?.message}</p>} */}
       {/* Affichage du label à droite si labelRight est vrai */}
          {labelRight && (
            <>
              {label} {ismandatory && <em className="text-danger">*</em>}
            </>
          )}
    </div>
  );
};

export default CheckboxInput;